import { render, staticRenderFns } from "./AscUserManagementGrid.vue?vue&type=template&id=10c871ac&scoped=true&"
import script from "./AscUserManagementGrid.vue?vue&type=script&lang=js&"
export * from "./AscUserManagementGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscUserManagementGrid.vue?vue&type=style&index=0&id=10c871ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c871ac",
  null
  
)

export default component.exports